import { AxiosError } from 'axios';
import moment from 'moment';

import { MenuItem } from '@src/components/Sidebar/types';
import { profile } from '@src/lib/imgUrl';

//@TODO routes should be in different file not in constant
const UiRoutes = {
  DASHBOARD: '/dashboard',
  LOGIN: '/login',
  HOME: '/home',
  ROOMS_MANAGEMENT: '/rooms',
  ROOM_DETAILS: '/room-details/:id',
  CREATE_ROOM: '/create-room',
  EDIT_ROOM: '/edit-room/:id',
  LOCATIONS_MANAGEMENT: '/locations',
  LOCATION_DETAILS: '/location-details/:id',
  CREATE_LOCATION: '/create-location',
  EDIT_LOCATION: '/edit-location/:id',
  USERS_MANAGEMENT: '/users',
  SCHEDULING: '/scheduling',
  BOOKING: '/bookings',
  NEW_BOOKING: '/new-bookings',
  ORGANIZATION: '/organizations',
  USER_DETAILS: '/location-details/:id',
  CREATE_USER: '/create-location',
  EDIT_USER: '/edit-location/:id',
  DEVICES: '/devices',
  DEVICE_LOG_HA: '/home-assistant/logs',
  DEVICE_LOG_HA_ID: '/home-assistant/logs/:id',
  METRICS: '/metrics',
  ROOM_DYNAMIC_FLOOR: '/dynamic-floors',
  NABU_CASA: '/home-assistant/instances',
};

export const menuItems = (role: string, path: string): MenuItem[] => {
  switch (role) {
    case 'super_admin':
      return [
        { label: 'Scheduling', route: path + UiRoutes.SCHEDULING },
        { label: 'Live Floors', route: path + UiRoutes.ROOM_DYNAMIC_FLOOR },
        { label: 'Rooms', route: path + UiRoutes.ROOMS_MANAGEMENT },
        { label: 'Locations', route: path + UiRoutes.LOCATIONS_MANAGEMENT },
        { label: 'Metrics', route: path + UiRoutes.METRICS },
        { label: 'Users', route: path + UiRoutes.USERS_MANAGEMENT },
        { label: 'Home Assistant', route: path + UiRoutes.DEVICE_LOG_HA },
        { label: 'HA Instances', route: path + UiRoutes.NABU_CASA },
        { label: 'Bookings', route: path + UiRoutes.NEW_BOOKING },
        // { label: 'Devices', route: UiRoutes.DEVICES+path },
        { label: 'History', route: path + UiRoutes.BOOKING },
        { label: 'Organization', route: path + UiRoutes.ORGANIZATION },
      ];
    case 'global_manager':
      return [
        { label: 'Rooms', route: path + UiRoutes.ROOMS_MANAGEMENT },
        { label: 'Locations', route: path + UiRoutes.LOCATIONS_MANAGEMENT },
        { label: 'Users', route: path + UiRoutes.USERS_MANAGEMENT },
        { label: 'Scheduling', route: path + UiRoutes.SCHEDULING },
        { label: 'Booking', route: path + UiRoutes.BOOKING },
      ];
    case 'local_manager':
      return [
        { label: 'Rooms', route: path + UiRoutes.ROOMS_MANAGEMENT },
        { label: 'Scheduling', route: path + UiRoutes.SCHEDULING },
        { label: 'Locations', route: path + UiRoutes.LOCATIONS_MANAGEMENT },
        { label: 'Users', route: path + UiRoutes.USERS_MANAGEMENT },
        { label: 'Booking', route: path + UiRoutes.BOOKING },
      ];
    case 'org_manager':
      return [
        { label: 'Rooms', route: path + UiRoutes.ROOMS_MANAGEMENT },
        { label: 'Locations', route: path + UiRoutes.LOCATIONS_MANAGEMENT },
        { label: 'Users', route: path + UiRoutes.USERS_MANAGEMENT },
        { label: 'Booking', route: path + UiRoutes.BOOKING },
      ];
    default:
      return [
        { label: 'Rooms', route: path + UiRoutes.ROOMS_MANAGEMENT },
        { label: 'Scheduling', route: path + UiRoutes.SCHEDULING },
        { label: 'Locations', route: path + UiRoutes.LOCATIONS_MANAGEMENT },
        { label: 'Users', route: path + UiRoutes.USERS_MANAGEMENT },
        { label: 'Booking', route: path + UiRoutes.BOOKING },
      ];
  }
};

const routeMapping = {
  [UiRoutes.ROOMS_MANAGEMENT]: [
    UiRoutes.CREATE_ROOM,
    UiRoutes.EDIT_ROOM.replace('/:id', ''),
    UiRoutes.ROOM_DETAILS.replace('/:id', ''),
  ],
  [UiRoutes.LOCATIONS_MANAGEMENT]: [
    UiRoutes.CREATE_LOCATION,
    UiRoutes.EDIT_LOCATION.replace('/:id', ''),
    UiRoutes.LOCATION_DETAILS.replace('/:id', ''),
  ],
};

interface PathTitleMap {
  [path: string]: string;
}

const pathTitleMap: PathTitleMap = {
  [UiRoutes.ROOMS_MANAGEMENT]: 'Rooms Management',
  [UiRoutes.CREATE_ROOM]: 'Rooms Management > Create Room',
  [UiRoutes.EDIT_ROOM.replace('/:id', '')]: 'Edit Room',
  [UiRoutes.ROOM_DETAILS.replace('/:id', '')]: 'Room Details',
  [UiRoutes.LOCATIONS_MANAGEMENT]: 'Location Management',
  [UiRoutes.NABU_CASA]: 'Home Assistant Instances',
  [UiRoutes.CREATE_LOCATION]: 'Location Management > Create Location',
  [UiRoutes.EDIT_LOCATION.replace('/:id', '')]: 'Edit Location',
  [UiRoutes.LOCATION_DETAILS.replace('/:id', '')]: 'Location Details',
};

export function getPathTitle(path: string): string {
  return pathTitleMap['/' + path.split('/')[1]] || '';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getDefaultRoute(userData?: any): string {
  if (userData?.role === 'room_display' && userData?.roomId) {
    return UiRoutes.ROOM_DETAILS.replace(':id', userData.roomId);
  }

  return UiRoutes.SCHEDULING;
}

export const profileData = {
  profileIcon: profile,
  userName: 'Phillip Vaccaro',
  userRole: 'Admin',
};
const validEmail = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
const validNameRegex = /^[a-zA-Z][a-zA-Z0-9 ]*$/;
const uaePhoneNumberRegex = /^\+971(5[0245689][0-9]{7}|2[0-9]{7}|3[0-9]{7}|4[0-9]{7}|6[0-9]{7}|7[0-9]{7}|9[0-9]{7})$/;

const statusCodes = {
  API_SUCCESS_CODE: 200,
  API_CREATE_SUCCESS_CODE: 201,
  API_ERROR_CODE: 404,
  API_ERROR_CONFIRMATION_CODE: 400,
};

export const NO_DATA_MESSAGE = 'Sorry but there is no data try to create new';
export const NO_RESULTS_MATCH = 'No matches found. Please refine your search criteria.';

export const dateFormat = (date: string | undefined) => {
  const parsedDate = moment(date);

  return parsedDate.format('DD-MM-YYYY');
};

export const dateFormatter = (dateStr: string) => {
  const parsedDate = moment(dateStr);
  return parsedDate.format('YYYY-MM-DD');
};

export const getErrorMessage = (error: unknown) => {
  const axiosError = error as AxiosError<{ message?: string }>;

  const message = axiosError?.response?.data?.message ?? 'An unexpected error occurred. Please try again later.';

  console.error('An error occurred:', axiosError);

  return message;
};

export const GOOGLE_MAP_API_STATUS_CODE = 'OK';

const conferenceOptions = [
  { label: 'Conference', value: 'conference' },
  { label: 'Hotel', value: 'hotel' },
];

const capacityOptions = [
  { label: '1 person', value: '1 person' },
  { label: '2 persons', value: '2 persons' },
  { label: '4 persons', value: '4 persons' },
  { label: '6 persons', value: '6 persons' },
  { label: '8 persons', value: '8 persons' },
  { label: '10 persons', value: '10 persons' },
  { label: '12 persons', value: '12 persons' },
  { label: '14 persons', value: '14 persons' },
  { label: '20+ persons', value: '20+ persons' },
];

const mediaSupportOptions = [
  { label: 'none', value: 'none' },
  { label: 'audio-video', value: 'audio-video' },
  { label: 'video-only', value: 'video-only' },
  { label: 'audio-only', value: 'audio-only' },
];

const maxTimeLimitOptions = [
  { label: 'full-day', value: 'full-day' },
  { label: '1-hour', value: '1-hour' },
  { label: '2-hour', value: '2-hour' },
  { label: '4-hour', value: '4-hour' },
];

const deviceTypeOptions = [
  { label: 'none', value: 'none' },
  { label: 'illumination', value: 'illumination' },
  { label: 'Occupancy', value: 'occupancy' },
];

export const time = [
  '7:00 am',
  '7:30 am',
  '8:00 am',
  '8:30 am',
  '9:00 am',
  '9:30 am',
  '10:00 am',
  '10:30 am',
  '11:00 am',
  '11:30 am',
  '12:00 pm',
  '12:30 pm',
  '1:00 pm',
  '1:30 pm',
  '2:00 pm',
  '2:30 pm',
  '3:00 pm',
  '3:30 pm',
  '4:00 pm',
  '4:30 pm',
  '5:00 pm',
  '5:30 pm',
  '6:00 pm',
  '6:30 pm',
];

export const timeSch = [
  '6:00 am',
  '7:00 am',
  '8:00 am',
  '9:00 am',
  '10:00 am',
  '11:00 am',
  '12:00 pm',
  '1:00 pm',
  '2:00 pm',
  '3:00 pm',
  '4:00 pm',
  '5:00 pm',
  '6:00 pm',
  '7:00 pm',
  '8:00 pm',
];

export enum DisableColor {
  BACKGROUND_COLOR = 'rgba(131, 131, 131, 0.8)',
  FONT_COLOR = 'white',
}

export {
  capacityOptions,
  conferenceOptions,
  deviceTypeOptions,
  maxTimeLimitOptions,
  mediaSupportOptions,
  routeMapping,
  statusCodes,
  uaePhoneNumberRegex,
  UiRoutes,
  validEmail,
  validNameRegex,
};
